(function (window) {
  'use strict';

  const API_BASE_URL = 'https://api.somosoest.com.br';
  const ADMIN_INFO_KEY = 'Oest:adminInfo';
  const LOGIN_PAGE = '/pages/admin-login';

  function getAdminInfo() {
    const raw = localStorage.getItem(ADMIN_INFO_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function requireAdminAuth() {
    const admin = getAdminInfo();
    if (!admin) {
      window.location.href = LOGIN_PAGE;
      return null;
    }
    return admin;
  }

  function forceAdminLogout() {
    localStorage.removeItem(ADMIN_INFO_KEY);
    window.location.href = LOGIN_PAGE;
  }

  async function performAdminLogout() {
    try {
      await fetch(API_BASE_URL + '/admin/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
    } finally {
      forceAdminLogout();
    }
  }

  let retokenPromise = null;

  function requestRetoken() {
    if (!retokenPromise) {
      retokenPromise = fetch(API_BASE_URL + '/admin/retoken', {
        method: 'POST',
        credentials: 'include',
      }).finally(function () {
        retokenPromise = null;
      });
    }
    return retokenPromise;
  }

  async function secureFetch(url, options) {
    options = options || {};
    options.credentials = 'include';
    options.headers = Object.assign({}, options.headers);
    if (options.body && !options.headers['Content-Type']) {
      options.headers['Content-Type'] = 'application/json';
    }

    let response = await fetch(url, options);

    if (response.status === 401) {
      const retokenResponse = await requestRetoken();
      if (retokenResponse.ok) {
        response = await fetch(url, options);
      } else {
        forceAdminLogout();
        throw new Error('Sessão expirada. Faça login novamente.');
      }
    }

    if (response.status === 403) {
      forceAdminLogout();
      throw new Error('Acesso negado.');
    }

    return response;
  }

  function el(tag, options, children) {
    const node = document.createElement(tag);
    options = options || {};
    if (options.class) node.className = options.class;
    if (options.text !== undefined) node.textContent = options.text;
    if (options.attrs) {
      Object.keys(options.attrs).forEach(function (key) {
        node.setAttribute(key, options.attrs[key]);
      });
    }
    (children || []).forEach(function (child) {
      if (child) node.appendChild(child);
    });
    return node;
  }

  function clearNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  window.OestAdmin = {
    API_BASE_URL: API_BASE_URL,
    getAdminInfo: getAdminInfo,
    requireAdminAuth: requireAdminAuth,
    secureFetch: secureFetch,
    performAdminLogout: performAdminLogout,
    forceAdminLogout: forceAdminLogout,
    el: el,
    clearNode: clearNode,
  };
})(window);
